import { Typography, Stack } from "@mui/material";
import { UnstyledLink } from "Components/Routes/UnstyledLink";
import { Resources, useResource } from "Translations/Resources";

const RESOURCES = Resources.Components.Affiliate.MerchantAffiliate;

export const MerchantAffiliateDescription = () => {
  const { t } = useResource();

  return (
    <Stack gap={4}>
      <Typography variant="h6">{t(RESOURCES.Title)}</Typography>
      <Typography whiteSpace="pre-line">{t(RESOURCES.Description)}</Typography>
      <Typography>
        {t(RESOURCES.TermsLinkPretext)}{" "}
        <UnstyledLink
          to={t(RESOURCES.TermsLinkUrl)}
          target="_blank"
          rel="noreferrer"
        >
          {t(RESOURCES.TermsLink)}
        </UnstyledLink>
        .
      </Typography>
      <Typography>{t(RESOURCES.InviteNow)}</Typography>
    </Stack>
  );
};
